(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tactical-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boreal-tactical-tabs')) {
    class BorealTacticalTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.selectTab(button));
          button.addEventListener('keydown', (event) => this.handleKeydown(event, button));
        });
      }

      selectTab(button) {
        this.buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== button.dataset.tab;
        });
        button.focus();
      }

      handleKeydown(event, button) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const currentIndex = this.buttons.indexOf(button);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.buttons.length) % this.buttons.length;
        this.selectTab(this.buttons[nextIndex]);
      }
    }
    customElements.define('boreal-tactical-tabs', BorealTacticalTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
